import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { copy } from '../../copy/es';
import { api, textoDeError } from '../../lib/api';
import { useSesion } from '../sesion';

/** Forced password change on first sign-in or after a reset (R-08). Same card as screen 1. */
export function CambioClavePage() {
  const { recargar } = useSesion();
  const navegar = useNavigate();
  const [actual, setActual] = useState('');
  const [nueva, setNueva] = useState('');
  const [confirmar, setConfirmar] = useState('');
  const [error, setError] = useState<string | null>(null);
  const c = copy.admin.cambioClave;

  async function guardar(e: FormEvent) {
    e.preventDefault();
    setError(null);
    if (nueva !== confirmar) return setError(c.noCoinciden);
    try {
      await api('/api/admin/sesion/clave', {
        method: 'PUT',
        body: JSON.stringify({ actual, nueva }),
      });
      await recargar();
      navegar('/admin/cargue', { replace: true });
    } catch (err) {
      setError(textoDeError(err));
    }
  }

  return (
    <div className="stage">
      <section className="screen">
        <div className="card sm">
          <div className="p-head">
            <span className="logo-wrap">
              <img className="logo" src="/coninsa-logo.svg" alt="Coninsa" />
            </span>
            <div className="right">
              <div className="t">{copy.admin.titulo}</div>
              <div className="by">{copy.app.gobernadoPor.toUpperCase()}</div>
            </div>
          </div>
          <form className="p-body" onSubmit={guardar}>
            <h2>{c.titulo}</h2>
            <p className="sub">{c.subtitulo}</p>
            <div className="field">
              <label htmlFor="actual">{c.actual}</label>
              <input
                id="actual"
                type="password"
                autoComplete="current-password"
                value={actual}
                onChange={(e) => setActual(e.target.value)}
                required
              />
            </div>
            <div className="field">
              <label htmlFor="nueva">{c.nueva}</label>
              <input
                id="nueva"
                type="password"
                autoComplete="new-password"
                minLength={12}
                value={nueva}
                onChange={(e) => setNueva(e.target.value)}
                required
              />
            </div>
            <div className="field">
              <label htmlFor="confirmar">{c.confirmar}</label>
              <input
                id="confirmar"
                type="password"
                autoComplete="new-password"
                minLength={12}
                value={confirmar}
                onChange={(e) => setConfirmar(e.target.value)}
                required
              />
            </div>
            {error && (
              <div className="err" role="alert">
                {error}
              </div>
            )}
            <button className="cta">{c.guardar}</button>
          </form>
        </div>
      </section>
    </div>
  );
}
